import { render, staticRenderFns } from "./AuthenticateDomainModal.vue?vue&type=template&id=3a9314c5&scoped=true"
import script from "./AuthenticateDomainModal.vue?vue&type=script&lang=js"
export * from "./AuthenticateDomainModal.vue?vue&type=script&lang=js"
import style0 from "./AuthenticateDomainModal.vue?vue&type=style&index=0&id=3a9314c5&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9314c5",
  null
  
)

export default component.exports